import { useAppContext } from "useAppContext";
import { useLoggedInAs } from "./useLoggedInAs";

export const DEFAULT_NOMENCLATURE = {
  membership: "Membership",
  member: "Member",
  members: "Members",
};

export const useNomenclature = () => {
  const loggedInAs = useLoggedInAs();
  const { organizations } = useAppContext();
  const organization = organizations?.find(
    org => org._id === loggedInAs?.entityId,
  );
  const nomenclature = organization?.metadata?.nomenclature;

  return {
    membership: nomenclature?.membership || DEFAULT_NOMENCLATURE.membership,
    member: nomenclature?.member || DEFAULT_NOMENCLATURE.member,
    members: nomenclature?.members || DEFAULT_NOMENCLATURE.members,
  };
};
